import { ComponentType, useEffect, useState } from 'react';

const SCROLL_THRESHOLD = 60; // px

export interface WithScrollThresholdProps {
  pastThreshold: boolean;
}

export function withScrollThreshold<T extends WithScrollThresholdProps>(WrappedComponent: ComponentType<T>) {
  return function ScrollAwareComponent(props: Omit<T, keyof WithScrollThresholdProps>) {
    const [pastThreshold, setPastThreshold] = useState(false);

    useEffect(() => {
      const scrollContainer = document.querySelector('main');
      if (!scrollContainer) return;

      const handleScroll = () => {
        setPastThreshold(scrollContainer.scrollTop > SCROLL_THRESHOLD);
      };

      scrollContainer.addEventListener('scroll', handleScroll);

      return () => {
        scrollContainer.removeEventListener('scroll', handleScroll);
      };
    }, []);

    return <WrappedComponent {...(props as T)} pastThreshold={pastThreshold} />;
  };
}
